module.exports = __webpack_public_path__ + "images/mdj/members/message/setmobilenew/setmobilenew_img01-ebf12c73af704f7e01dcdfc3243617d7.jpg";